// extracted by mini-css-extract-plugin
export default {"line-based":"icons_line-based__YTo0z","inline":"icons_inline__SzJCP"};